export default __webpack_public_path__ + "static/media/anesthesiology.8de4167e.png";